// i18n area 'hci' — locale pt-BR (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da hci.pt-PT.ts e sovrascrive SOLO le chiavi
// che il brasiliano scrive davvero in un altro modo: lessico (usuário,
// arquivo, tela, senha, registro, seção, configurações, salvar, console) e
// morfologia verbale (il progressivo 'está a fazer' → 'está fazendo').
// DA RIVEDERE DA MADRELINGUA: restano fuori le scelte a bassa confidenza
// (alojar/hospedar, eliminar/excluir, arranque/inicialização) e la posizione
// dei clitici, che una regola meccanica non sa spostare.
// Sidecar anti-stantie: ../meta/hci.pt-BR.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './hci'

export const ptBR: DeepPartial<typeof enUS> = {
  hci: {
    ceph: {
      detail: {
        unregisterDevice: 'Anular registro',
        activeDeviceGuard: 'OSD ativo — sai pelo ciclo de vida OSD, não pelo registro'
      },
      pin: {
        hint: 'Endereçamento por daemon: vazio = o Ceph agarra-se sozinho dentro da rede declarada; preenchido = esta instância fica pinada ao endereço na sua seção de conf.'
      },
      rawEditor: {
        hint: 'Desligado (default) = a superfície guiada das regras é a ferramenta standard. Ligado = o tab CRUSH mostra também a crushmap decompilada como texto editável. Salvar exige sempre sudo, o nome do cluster como confirmação, e passa por compile + test do crushtool ANTES de chegar ao cluster.'
      },
      osdFlags: {
        standardFlowsHint: 'Os fluxos standard da plataforma gerenciam estas flags sozinhos nos casos normais (a manutenção de um nó define um noout circunscrito, a substituição de um disco passa pelo ciclo de vida OSD). Esta seção é o override manual para o operador que sabe o que está fazendo.'
      },
      pools: {
        ruleSudoHint: 'Alterar a regra CRUSH exige a senha do operador.'
      },
      crush: {
        rackGuardHint: 'Nenhum bucket rack existe na hierarquia observada: a regra pode ser criada na mesma, mas nenhuma pool poderá apontar para ela enquanto um rack não for declarado no posicionamento dos servidores membros (configurações do nó) — a task de realinhamento constrói o bucket e a associação abre-se sozinha.',
        treeHint: 'O mapa CRUSH tal como o cluster o vê: root → níveis declarados → servidores (hosts) → OSDs. A topologia segue o posicionamento declarado de cada servidor (configurações do nó) — uma mudança de posição realinha-a via task.',
        unplacedWarning: 'Membros sem posição declarada: {nodes} — os seus hosts ficam diretamente sob a root, fora da topologia declarada. Declare a posição nas configurações do nó (um aviso, nunca um bloqueio).',
        rawWarning: 'PERIGO: este texto é TODA a política de posicionamento do cluster. Um mapa errado pode partir o placement de todas as pools ao mesmo tempo. Salvar compila e testa o mapa com o crushtool ANTES de o injetar — mas um mapa válido pode ainda assim ser uma má ideia.',
        rawLoading: 'Query em curso — uma task read-only está decompilando a crushmap…',
        rawSave: 'Salvar crushmap'
      },
      objects: {
        loading: 'Query em curso — uma task read-only está interrogando o cluster…'
      },
      registerDevice: {
        hint: 'Num cluster vivo o registro também PREPARA o dispositivo: torna-se um OSD BlueStore com uma task automática com afinidade ao nó (nunca vazio, ratificado 2026-07-24). Um dispositivo pertence no máximo a um cluster Ceph em toda a frota.',
        noDeclared: 'Nenhum disco de dados declarado neste nó — marque-os primeiro nas configurações locais do nó',
        encryptedHint: 'A escolha por OSD (o modo do cluster é "escolhida por cada OSD"): congela-se neste disco no momento do registro — uma mudança de modo posterior nunca a reescreve; fá-lo a ação de linha criptografar/desencriptar.',
        error: 'O registro foi recusado'
      },
      unregisterDevice: {
        title: 'Anular registro do dispositivo',
        body: 'Só registro: {name} deixa de ser um candidato a OSD deste cluster. Os seus bytes não são tocados.',
        error: 'A anulação do registro foi recusada'
      },
      propose: {
        started: 'Proposta aceita — o storage está se materializando; encontra-o em Storage'
      },
      fs: {
        deleteBody: 'O filesystem {fs} e CADA arquivo dentro dele são destruídos irreversivelmente — as suas pools de dados e metadata morrem com ele. Escreva o nome do filesystem para confirmar.'
      },
      destroy: {
        retryGuard: 'A destruição está em execução — o retry vale para uma destruição falhada (o lease recusa caso contrário)'
      },
      delete: {
        body: 'A configuração e o seu registro de dispositivos são removidos. Legal só enquanto nada estiver deployado.'
      }
    }
  }
}
